import {
  Grid,
  FormField,
  Input,
  Checkbox,
  Button,
  Box,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { Mail, Phone } from 'lucide-react';
import { IUserMDB } from '../../../lib/models/interfaces';
import { UserContext } from '../../../context/authContext';

export const UserRow = (props: {
  user: IUserMDB;
  key: number;
  setShowUpdateUser: (arg: boolean) => void;
  setUpdateIndex: (arg: number) => void;
  index: number;
  activateUser: (index: number) => void;
  deactivateUser: (index: number) => void;
}) => {
  const {
    user,
    setShowUpdateUser,
    setUpdateIndex,
    key,
    index,
    deactivateUser,
    activateUser
  } = props;
  const { user: MainUser } = useContext(UserContext);

  return (
    <div className="flex ">
      <div
        className={`inline-block w-80 rounded-2xl border border-gray-200 bg-white p-6 shadow mr-4 ${user.deactivated ? ' shadow-xl shadow-red-500/30' : ''}`}
      >
        <div className="space-y-1">
          <h3 className="text-lg font-semibold text-gray-900">{user.name}</h3>
          <p className="flex items-center text-sm text-gray-600">
            <Mail className="w-4 h-4 mr-2" /> {user.email}
          </p>
          <p className="flex items-center text-sm text-gray-600">
            <Phone className="w-4 h-4 mr-2" /> {user.contactNumber}
          </p>
        </div>

        <div className="mt-6 flex justify-end items-center gap-3">
          <button
            onClick={() => {
              user?.deactivated ? activateUser(index) : deactivateUser(index);
            }}
            disabled={MainUser.sub === user.sub ? true : false}
            type="button"
            className="inline-flex items-center justify-center rounded-lg border border-[#DA566B] px-4 py-2 text-sm font-medium text-[#B9495B] hover:bg-[#B9495B] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#B9495B] disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-600 disabled:ring-0"
          >
            {user?.deactivated ? 'Re-Activate' : 'Deactivate'}
          </button>
          <button
            onClick={() => {
              setShowUpdateUser(true);
              setUpdateIndex(index);
            }}
            type="button"
            className="inline-flex items-center justify-center rounded-lg bg-[#56dac5] px-4 py-2 text-sm font-medium text-white hover:bg-[#2CC9B0] focus:outline-none focus:ring-2 focus:ring-[#2CC9B0]"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};
